export default [
  { id: 'title', label: 'Title' },
  { id: 'text', label: 'Text' },
  { id: 'createdAt', label: 'Date' },
];
